<template>
  <div v-if="permissionTasksManagementPackageComputed" class="popup-window-center">
<!--    Popups-->

    <DocumentsPopup v-if="showDocumentsPopup"
                    v-on:close="closeDocumentsPopupFunc"
                    :record-id="documentPopupId"
                    :record-type="constants.recordType.Tasks"
    ></DocumentsPopup>

    <NotesPopup v-if="showNotesPopup"
                v-on:close="closeNotesPopupFunc"
                :record-id="notesPopupId"
                :record-type="constants.recordType.Tasks"
    ></NotesPopup>

<!--    End Popups-->
    <div class="popup-body">
      <div class="card card-small member-tasks-card">

        <div class="card-header member-tasks-header d-flex justify-content-between">
          <div class="member-tasks-heading">
            <span class="material-icons member-tasks-icon" aria-hidden="true">task_alt</span>
            <div class="area-title">{{ $t('general.tasks.tasks') }}</div>
          </div>
          <button type="button" class="member-tasks-close" :aria-label="$t('general.tasks.close')" @click="close">
            <span class="material-icons" aria-hidden="true">close</span>
          </button>
        </div>

        <div class="card-body member-tasks-body">
          <div class="task-form task-quick-create">
            <div class="task-quick-field task-quick-field--wide" :class="invalidClass('description')">
              <label>{{ $t('general.tasks.description') }} <span class="required-mark">*</span></label>
              <d-input :placeholder="$t('general.tasks.description')" v-model="$v.newTaskObj.description.$model"></d-input>
            </div>
            <div class="task-quick-row">
              <div class="task-quick-field" :class="invalidClass('dueDate')">
                <label>{{ $t('general.tasks.dueDate') }} <span class="required-mark">*</span></label>
                <div class="task-date-control">
                  <CalendarIcon class="calendar-icon-control" />
                  <div class="d-flex w-100 align-items-center" :class="{'clear-enabled':newTaskDueDate}">

                    <datetime
                      type="date"
                      v-model="$v.newTaskObj.dueDate.$model"
                      input-class="form-control w-100 input-for-clear"
                      class="theme-light-blue w-100"
                      :format-commenteddddd="{ year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: '2-digit', timeZoneName: 'short' }"
                      format="yyyy-MM-dd"
                      :phrases-commenteddddd="{ok: 'Continue', cancel: 'Exit'}"
                      :hour-step="1"
                      :minute-step="1"
                      :week-start="7"
                      :placeholder="$t('general.tasks.dueDate')"
                      use12-hour
                      auto
                    ></datetime>

                    <d-button theme="secondary" @click="newTaskDueDate=undefined" class="clear-icon-size">
                      <span class="material-icons">
                       clear
                      </span>
                    </d-button>
                  </div>
                </div>
              </div>

              <div class="task-quick-field" :class="invalidClass('ownerId')">
                <label>{{ $t('general.tasks.owner') }} <span class="required-mark">*</span></label>
                <DropdownAutoComplete :key="ownerInputKey" v-on:input="getAllMembersCustomersByName" v-model="$v.newTaskObj.ownerId.$model" :is-async="true"
                                      continer-class="w-100" dropdown-class="" input-class="form-control"
                                      :items="ownerLstOptions" :placeholder="$t('general.tasks.selectOwner')">
                </DropdownAutoComplete>
              </div>
              <div class="task-quick-action">
                <d-button @click="saveNewTask">{{ $t('general.tasks.add') }}</d-button>
              </div>
            </div>

          </div>
          <div class="member-tasks-filters">
            <d-select v-model="taskStatusFilter" class="filter-width">
              <option :value="undefined">{{ $t('general.tasks.selectStatus') }}</option>
              <option v-for="taskStatus in taskStatusLst" :value="taskStatus.id" :key="'taskStatus'+taskStatus.id">{{
                  $i18n.locale === 'en' ? taskStatus.nameEn : taskStatus.nameAr
                }}
              </option>
            </d-select>

            <d-checkbox class="mb-0" v-model="tasksShowOnlyMyTaskFilter">{{ $t('general.tasks.showOnlyMyTasks') }}</d-checkbox>
          </div>
          <div class="content-container-overflow">
            <table class="table table-striped-custom table-hover-custom mb-0">
              <thead class="bg-light">
              <tr>
                <th scope="col" class="border-0 no-wrap-text" width="40%">{{ $t('general.tasks.task') }}</th>
                <th scope="col" class="border-0 no-wrap-text" width="30%">{{ $t('general.tasks.owner') }}</th>
                <th scope="col" class="border-0 no-wrap-text" width="30%">{{ $t('general.tasks.createdBy') }}</th>
                <th scope="col" class="border-0 no-wrap-text" width="30%">{{ $t('general.tasks.status') }}</th>
                <th scope="col" class="border-0 no-wrap-text" width="30%">{{ $t('general.tasks.dueDate') }}</th>
                <th v-if="permissionNotesManagementPackageComputed" scope="col" class="border-0 menu-cell"></th>
                <th v-if="permissionNotesManagementPackageComputed" scope="col" class="border-0 menu-cell"></th>
                <th scope="col" class="border-0 menu-cell"></th>
                <th scope="col" class="border-0 menu-cell"></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="task in tasksLst" :key="task.id">
                <td>{{ task.description }}</td>
                <td>{{ task.ownerData ? $fullName(task.ownerData.givenName, task.ownerData.middleName, task.ownerData.familyName) : '' }}</td>
                <td>{{ task.assignedByFullName }}</td>
                <td>
                  <StatusBadge
                    :status="task.statusData ? (task.statusData.code || task.statusData.nameEn) : null"
                    :label="task.statusData
                      ? ($i18n.locale === 'en' ? task.statusData.nameEn : task.statusData.nameAr)
                      : $t('generalMessages.NA')"
                  />
                </td>
                <td>{{ formatDate(task.dueDate) }}</td>
                <td v-if="permissionNotesManagementPackageComputed">
                  <span @click="showNotesPopupFunc(task.id)" class="link link-secondary link-hover d-flex align-items-center justify-content-end">
                    <span class="material-icons">article</span>
                    {{ $t('general.tasks.notes') }}</span>
                </td>
                <td v-if="permissionNotesManagementPackageComputed">
                  <span @click="showDocumentsPopupFunc(task.id)" class="link link-secondary link-hover d-flex align-items-center justify-content-end">
                    <span class="material-icons"> file_present </span>
                    {{ $t('general.tasks.documents') }}</span>
                </td>
                <td>
                  <span @click="changeStatusTask(task.id,constants.statusesCode.task.done)" class="link link-secondary link-hover white-space-nowrap d-flex align-items-center justify-content-end">
                    <span class="material-icons">check_circle_outline</span>
                    {{ $t('general.tasks.markComplete') }}</span>
                </td>
                <td>
                  <span class="link link-secondary link-hover d-flex align-items-center justify-content-end" @click="changeStatusTask(task.id,constants.statusesCode.task.canceled)">
                    <span class="material-icons">remove_circle_outline</span>
                    {{ $t('general.tasks.cancel') }}</span>
                </td>
              </tr>
              </tbody>
            </table>
                <PaginationBar
      :totalPages="totalPages"
      :totalCount="totalCount"
      :perPage.sync="perPage"
      :currentPage="currentPage"
      @pagechanged="onPageChange"
    />
          </div>
          <div class="member-tasks-footer">
            <button type="button" class="btn btn-light member-tasks-close-action" @click="close">
              {{ $t('general.tasks.close') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { Datetime } from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css';
import DropdownAutoComplete from '@/components/DropdownAutoComplete';
import constants from '@/utils/constants';
import NotesPopup from '@/components/General/Notes/NotesPopup';
import DocumentsPopup from '@/components/General/Documents/DocumentsPopup';
import { required } from 'vuelidate/lib/validators';
import tasksService from '@/services/tasks.service';
import lookupsService from '@/services/lookups.service';
import usersService from '@/services/users.service';
import PaginationBar from '@/components/Pagination/PaginationBar.vue';

export default {
  name: 'TasksPopup',
  components: {
    DocumentsPopup,
    NotesPopup,
    DropdownAutoComplete,
    datetime: Datetime,
    PaginationBar,
  },
  props: {
    recordId: {
      required: true,
      type: Number,
    },
    recordType: {
      required: true,
      type: Object,
      default() {
        return {
          entity: '',
          fieldName: '',
          fieldNameForObject: '',
        };
      },
    },
  },
  data() {
    return {
      submitAttempted: false,
      constants,
      tasksLst: [],

      totalCount: 0,
      perPage: this.$store.state.settings.defaultPageSize,
      currentPage: 1,
      totalPages: 0,

      newTaskDescription: '',
      newTaskDueDate: undefined,
      ownerInputKey: 0,

      ownerLst: [],
      ownerLstOptions: [],
      newTaskOwner: undefined,

      taskStatusFilter: undefined,
      tasksShowOnlyMyTaskFilter: undefined,

      taskStatusLst: [],

      showDocumentsPopup: false,
      documentPopupId: undefined,

      showNotesPopup: false,
      notesPopupId: undefined,

      newTaskObj: {
        id: undefined,
        createdBy: undefined,
        lastModifiedBy: undefined,
        dateCreated: '',
        dateModified: '',
        description: '',
        statusId: undefined,
        ownerId: undefined,
        dueDate: '',
        referenceMemberId: undefined,
        referenceMembershipId: undefined,
        referenceSaleOrderId: undefined,
        referencePaymentId: undefined,
        referenceExpenseId: undefined,
        referenceProductId: undefined,
        referenceProductTransactionId: undefined,
        referenceSaleId: undefined,
      },

    };
  },
  validations: {
    newTaskObj: {
      description: {
        required,
      },
      ownerId: {
        required,
      },
      dueDate: {
        required,
      },
    },
  },
  created() {
    this.getTasks();
    this.getStatuses();
    this.newTaskObj[this.recordType.fieldNameForObject] = this.recordId;
  },
  methods: {
    invalidClass(field) {
      const rule = this.$v.newTaskObj[field];
      return { 'field-missing': Boolean(this.submitAttempted && rule && rule.$error) };
    },
    saveNewTask() {
      this.submitAttempted = true;
      this.$v.$touch();
      if (this.$v.$invalid) return;
      this.newTaskSubmit();
    },
    onPageChange(page) {
      this.currentPage = page;
      this.getTasks();
    },
    async getTasks() {
      this.$store.commit('changeShowLoader', true);
      await tasksService.list({
        Status: this.taskStatusFilter ? this.taskStatusFilter : '',
        [this.recordType.fieldName]: this.recordId,
        filters: this.tasksShowOnlyMyTaskFilter ? constants.taskFilter.assignedToMe : constants.taskFilter.all,
        page: this.currentPage,
        perPage: this.perPage,
      })
        .then((data) => {
          if (data) {
            this.tasksLst = data.data;
            this.totalCount = data.totalItemCount;
            this.totalPages = Math.ceil(this.totalCount / this.perPage);
          } else {
            throw 'Server return status false';
          }
        })
        .catch((err) => {
          this.showError(err, this.$t('errors.entities.tasks'), 'load');
        });
      this.$store.commit('changeShowLoader', false);
    },

    async getStatuses() {
      this.$store.commit('changeShowLoader', true);
      await lookupsService.getStatuses({ Category: constants.statusesCategory.task })
        .then((data) => {
          if (data && data.status) {
            this.taskStatusLst = data.data;
          } else {
            throw 'server return status = false';
          }
        })
        .catch((err) => {
          this.showError(err, this.$t('errors.entities.tasks'), 'load');
        });
      this.$store.commit('changeShowLoader', false);
    },

    async getAllMembersCustomersByName(name) {
      // this.$store.commit('changeShowLoader', true);
      if (!name || name.length < 2) {
        this.ownerLstOptions = [];
        this.ownerLst = [];
        this.newTaskOwner = undefined;
        return;
      }
      await usersService.searchByFullName(name, { includeTrainers: true })
        .then((data) => {
          if (data && data.data && data.data.length > 0) {
            this.ownerLst = data.data;
            this.ownerLstOptions = data.data.map((m) => ({
              value: m.id,
              text: this.$fullName(m.givenName, m.middleName, m.familyName),
            }));
          } else {
            this.ownerLstOptions = [];
            this.ownerLst = [];
            this.newTaskOwner = undefined;
          }
        })
        .catch((err) => {
          this.showError(err, this.$t('errors.entities.tasks'), 'load');
          this.ownerLstOptions = [];
          this.ownerLst = [];
          this.newTaskOwner = undefined;
        });
      // this.$store.commit('changeShowLoader', false);
    },
    async newTaskSubmit() {
      this.$store.commit('changeShowLoader', true);
      const taskObj = this.cleanEmptyAttrFromObj(this.newTaskObj);
      await tasksService.create(taskObj)
        .then(async (data) => {
          if (data) {
            this.$toast.success(this.$t('general.tasks.successAdd'));
            this.getTasks();
            await this.resetNewTaskForm();
          } else {
            throw 'Server return status false';
          }
        })
        .catch((err) => {
          this.showError(err, this.$t('errors.entities.task'), 'save');
        });
      this.$store.commit('changeShowLoader', false);
    },
    async resetNewTaskForm() {
      this.newTaskObj.description = undefined;
      this.newTaskObj.dueDate = undefined;
      this.newTaskObj.ownerId = undefined;
      this.newTaskOwner = undefined;
      this.ownerLst = [];
      this.ownerLstOptions = [{ value: undefined, text: '' }];
      this.ownerInputKey += 1;

      // Clear the render guard before child controls finish their model updates. Vuelidate
      // is reset after that render so those updates cannot immediately make the fields dirty.
      this.submitAttempted = false;
      await this.$nextTick();
      this.$v.$reset();
    },
    async changeStatusTask(taskId, statusCode) {
      this.$store.commit('changeShowLoader', true);
      await tasksService.updateStatus(taskId, statusCode)
        .then((data) => {
          if (data) {
            this.$toast.success(this.$t('general.tasks.successUpdate'));
            this.getTasks();
          } else {
            throw 'Server return status false';
          }
        })
        .catch((err) => {
          this.showError(err, this.$t('errors.entities.task'), 'save');
        });
      this.$store.commit('changeShowLoader', false);
    },
    close() {
      this.$emit('close');
    },

    async showDocumentsPopupFunc(itemId) {
      setTimeout(() => {
        this.showDocumentsPopup = true;
        this.documentPopupId = itemId;
      }, 50);
    },
    async closeDocumentsPopupFunc() {
      this.showDocumentsPopup = false;
      this.documentPopupId = undefined;
    },

    async showNotesPopupFunc(itemId) {
      setTimeout(() => {
        this.showNotesPopup = true;
        this.notesPopupId = itemId;
      }, 50);
    },
    async closeNotesPopupFunc() {
      this.showNotesPopup = false;
      this.notesPopupId = undefined;
    },

  },
  computed: {
    permissionNotesManagementPackageComputed() {
      return this.hasFeature('follow-ups');
    },
    permissionTasksManagementPackageComputed() {
      return this.hasFeature('tasks-management');
    },
    watchFilters() {
      return `${this.taskStatusFilter}|||${this.tasksShowOnlyMyTaskFilter}`;
    },
  },
  watch: {
    perPage() {
      this.currentPage = 1;
      this.getTasks();
    },
    watchFilters() {
      this.currentPage = 1;
      this.getTasks();
    },
  },
};
</script>

<style scoped>
/* The asterisk says which fields are required; this says which ones are still empty after the
   reader tried to save. Applied to the wrapper so it reaches whichever control the field uses. */
.field-missing ::v-deep .form-control,
.field-missing ::v-deep select,
.field-missing ::v-deep input,
.field-missing ::v-deep textarea {
  border-color: #c5163a;
}
.field-missing label { color: #c5163a; }

.member-tasks-card { border: 1px solid #e3ebf1; border-radius: 14px; box-shadow: 0 18px 50px rgba(31, 57, 80, .16); margin: 0 auto; max-height: min(90vh, 50rem); overflow: hidden; padding: 0; width: min(calc(100vw - 2rem), 72rem); }
.member-tasks-header { align-items: center; border-bottom: 1px solid #e8eef3; padding: 1rem 1.15rem; }
.member-tasks-heading { align-items: center; display: flex; gap: .65rem; }
.member-tasks-heading .area-title { color: #254766; font-size: 1.1rem; margin: 0; }
.member-tasks-icon { align-items: center; background: rgba(0, 152, 184, .1); border-radius: 9px; color: var(--fitnet-primary); display: inline-flex; font-size: 1.2rem; height: 2.35rem; justify-content: center; width: 2.35rem; }
.member-tasks-close { align-items: center; background: transparent; border: 0; border-radius: 7px; color: #71859a; cursor: pointer; display: inline-flex; height: 2.25rem; justify-content: center; padding: 0; width: 2.25rem; }
.member-tasks-close:hover,
.member-tasks-close:focus { background: #f1f6f8; color: #254766; }
.member-tasks-body { max-height: calc(90vh - 4.5rem); overflow: auto; padding: 1rem 1.15rem !important; }
.task-quick-create { background: #f8fbfc; border: 1px solid #e3ebf1; border-radius: 10px; padding: .85rem; }
.task-quick-row { align-items: end; display: grid; gap: .75rem; grid-template-columns: minmax(11rem, 1fr) minmax(12rem, 1fr) auto; margin-top: .7rem; }
.task-quick-field { display: grid; gap: .35rem; min-width: 0; }
.task-quick-field label { color: #60778e; font-size: .78rem; font-weight: 600; margin: 0; }
.task-date-control { align-items: center; display: flex; min-width: 0; position: relative; }
.task-date-control > .calendar-icon-control {
  inset-inline-end: .75rem;
  pointer-events: none;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;
}
.task-date-control ::v-deep .form-control { padding-inline-end: 2.5rem; }
.task-date-control ::v-deep .clear-enabled .form-control { padding-inline-end: 4.5rem; }
.task-quick-action { align-items: center; display: flex; min-height: 40px; }
.required-mark { color: #d14343; font-weight: 700; margin-inline-start: 2px; }
.content-container-overflow {
  border: 1px solid #e4ebf0;
  border-radius: 9px;
  max-height: 360px;
  overflow-y: auto;
}
.member-tasks-filters { align-items: center; display: flex; flex-wrap: wrap; gap: .75rem; margin: .85rem 0; }
.member-tasks-filters .filter-width { min-height: 40px; }
.member-tasks-footer { align-items: center; border-top: 1px solid #e8eef3; display: flex; justify-content: flex-end; margin: 1rem -1.15rem -1rem; padding: .85rem 1.15rem; }
.member-tasks-close-action { border-color: #dce4ea; color: #61768a; }
.content-container-overflow .link-hover { border-radius: 6px; gap: .25rem; padding: .3rem .4rem; text-decoration: none; white-space: nowrap; }
.content-container-overflow .link-hover .material-icons { font-size: 1.05rem; }

.button-container-relative {
  position: relative;
}

@media (max-width: 767px) {
  .task-quick-row { grid-template-columns: minmax(0, 1fr); }
  .task-quick-action .btn { width: 100%; }
  .member-tasks-filters { align-items: stretch; flex-direction: column; }
  .member-tasks-filters .filter-width { width: 100%; }
}
</style>
